export default __webpack_public_path__ + "7397963cd38a87350d4c5347e9ae0f47.pdf";